module.exports = __webpack_public_path__ + "static/media/menu_dashboard_geral.20ae5c98.png";